<template>
  <div>
    <p class="text-2xl">
      Consumo Whitelabel
    </p>

    <v-card
      flat
      class="mb-5"
    >
      <v-card-text class="pa-3">
        <v-row>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <v-autocomplete
              v-model="filterWhitelabelId"
              :items="whitelabels"
              label="Whitelabel"
              outlined
              dense
              hide-details
              item-text="value"
              item-value="id"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <date
              v-model="startDate"
              :type="'date'"
              outlined
              dense
              hide-details
              label="Data Início"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <date
              v-model="endDate"
              :type="'date'"
              outlined
              dense
              hide-details
              label="Data Fim"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
            sm="6"
            class="d-flex align-center"
          >
            <v-btn
              color="primary"
              block
              :disabled="!filterWhitelabelId"
              @click="fetchUsage"
            >
              Pesquisar
              <v-icon
                right
                dark
              >
                {{ icons.mdiMagnify }}
              </v-icon>
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
            class="d-flex align-center"
          >
            <v-btn
              color="secondary"
              outlined
              block
              :disabled="!filterWhitelabelId"
              @click="accessWhitelabel"
            >
              Acessar Whitelabel
              <v-icon
                right
                dark
              >
                {{ icons.mdiOpenInNew }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <template v-if="hasResult">
      <v-row class="mb-5">
        <v-col
          cols="12"
          md="4"
        >
          <v-card>
            <v-card-title class="align-start">
              <span class="font-weight-semibold">Saldo atual</span>
            </v-card-title>
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar
                  size="44"
                  color="success"
                  rounded
                  class="elevation-1"
                >
                  <v-icon
                    dark
                    color="white"
                    size="30"
                  >
                    {{ icons.mdiTrendingUp }}
                  </v-icon>
                </v-avatar>
                <div class="ms-3">
                  <h3 class="text-xl font-weight-semibold">
                    R$ {{ $money(usage.availableLimit, 2) }}
                  </h3>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-card>
            <v-card-title class="align-start">
              <span class="font-weight-semibold">Gasto no período</span>
            </v-card-title>
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar
                  size="44"
                  color="error"
                  rounded
                  class="elevation-1"
                >
                  <v-icon
                    dark
                    color="white"
                    size="30"
                  >
                    {{ icons.mdiCash }}
                  </v-icon>
                </v-avatar>
                <div class="ms-3">
                  <h3 class="text-xl font-weight-semibold">
                    R$ {{ $money(usage.totalSpent, 2) }}
                  </h3>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <v-card>
            <v-card-title class="align-start">
              <span class="font-weight-semibold">Campanhas no período</span>
            </v-card-title>
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar
                  size="44"
                  color="info"
                  rounded
                  class="elevation-1"
                >
                  <v-icon
                    dark
                    color="white"
                    size="30"
                  >
                    {{ icons.mdiFileChart }}
                  </v-icon>
                </v-avatar>
                <div class="ms-3">
                  <h3 class="text-xl font-weight-semibold">
                    {{ $money(usage.totalCampaigns, 0) }}
                  </h3>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <p class="text-2xl">
        Por tipo de serviço
      </p>

      <v-card
        flat
        class="mt-3"
      >
        <v-data-table
          :headers="headers"
          :items="usage.byService || []"
          item-key="serviceId"
          class="table-rounded"
          disable-sort
          dense
          no-data-text="Nenhum serviço encontrado no período."
        >
          <template #[`item.campaignCount`]="{ item }">
            {{ $money(item.campaignCount, 0) }}
          </template>
          <template #[`item.value`]="{ item }">
            R$ {{ $money(item.value, 2) }}
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { ref } from '@vue/composition-api'
import {
  mdiMagnify,
  mdiTrendingUp,
  mdiCash,
  mdiFileChart,
  mdiOpenInNew,
} from '@mdi/js'

export default {
  setup() {
    const filterWhitelabelId = ref(null)
    const whitelabels = ref([])
    const usage = ref(null)
    const hasResult = ref(false)

    return {
      filterWhitelabelId,
      whitelabels,
      usage,
      hasResult,
      icons: {
        mdiMagnify,
        mdiTrendingUp,
        mdiCash,
        mdiFileChart,
        mdiOpenInNew,
      },
      headers: [
        { text: 'Serviço', value: 'name' },
        { text: 'Qtd. Campanhas', value: 'campaignCount', align: 'right' },
        { text: 'Valor (R$)', value: 'value', align: 'right' },
      ],
    }
  },

  data() {
    return {
      startDate: this.$day().startOf('month').format('DD/MM/YYYY'),
      endDate: this.$day().format('DD/MM/YYYY'),
    }
  },

  async created() {
    await this.findWhitelabels()
  },

  methods: {
    ...mapActions('whitelabelUsage', {
      findUsage: 'find',
      createAccess: 'createAccess',
    }),

    async findWhitelabels() {
      this.whitelabels = [
        {
          id: 'hlYE7Wp80sZZYdSY0z4moJ2egIhXZZp6KRsu',
          value: 'Betenvios',
        },
        {
          id: 'HZAY4LTEb8C8YqgAW5csO14mgepgw47f7WEa',
          value: 'Hands',
        },
        {
          id: 'BS9mK2qT7xP4vR8cL1nF5wH3yD6uZ0aE',
          value: 'Boostsend',
        },
        {
          id: 'OE1aLfs28HE1D1s25LDwr8A4SSZu2hqfmPWcx',
          value: 'Daxx',
        },
      ]
    },

    async fetchUsage() {
      if (!this.filterWhitelabelId) {
        this.hasResult = false
        this.usage = null
        return
      }

      const params = {
        whitelabelId: this.filterWhitelabelId,
        startDate: this.$day(this.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        endDate: this.$day(this.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      }

      const data = await this.findUsage(params)

      if (data?.response || data instanceof Error) {
        const errorMessage =
          data?.response?.data?.message ??
          'Erro ao obter consumo do whitelabel'
        Vue.prototype.$toast?.error(
          Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage,
        )
        this.hasResult = false
        this.usage = null
        return
      }

      this.usage = {
        availableLimit: Number(data?.availableLimit ?? 0),
        totalSpent: Number(data?.totalSpent ?? 0),
        totalCampaigns: Number(data?.totalCampaigns ?? 0),
        byService: Array.isArray(data?.byService) ? data.byService : [],
      }
      this.hasResult = true
    },

    async accessWhitelabel() {
      if (!this.filterWhitelabelId) {
        return
      }

      const data = await this.createAccess({
        whitelabelId: this.filterWhitelabelId,
      })

      if (data?.response || data instanceof Error) {
        const errorMessage =
          data?.response?.data?.message ??
          'Erro ao gerar acesso ao whitelabel'
        Vue.prototype.$toast?.error(
          Array.isArray(errorMessage) ? errorMessage.join(', ') : errorMessage,
        )
        return
      }

      if (!data?.url) {
        Vue.prototype.$toast?.error('URL de acesso não recebida')
        return
      }

      window.open(data.url, '_blank', 'noopener,noreferrer')
    },
  },
}
</script>
